<template>
  <div class="d-flex flex-column">
    <div class="alert alert-danger mt-4" id="error_msg" v-html="errorMsg"></div>
  </div>
</template>

<script>
export default {
	props: ["searchType"],
	computed: {
		errorMsg() {
			const errorCode = this.$store.getters["searchStore/error"];
			if (errorCode === 400 || errorCode === 404 || errorCode === undefined) {
				return "No results found. Please check and try again.";
			} else {
				let example = "IP.<br> E.g. 2001:dc0::/32";
				if (this.searchType === "ip") {
					example = "IP.<br> E.g. 2001:dc0::/32";
				} else if (this.searchType === "autnum") {
					example = "ASN.<br> E.g. AS number for APNICs AS";
				} else if (this.searchType === "entity") {
					example = "Entity.<br> E.g. NO4-AP";
				}
				return "Please enter valid " + example;
			}
		}
	}
};
</script>

<style scoped>
</style>
